export const log = ({ name, parameters }) => {
    window.fbq('track', name, parameters)
}